import {CommonModule} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {Component} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AuthService} from './services/authService';
import {LocalStorageService} from './services/storage.service';
import {Title} from '@angular/platform-browser';
import {State} from './services/state';
import {environment} from './environments/environment';
import {timer} from 'rxjs';
import {FamilyService} from './services/family';
import {AppointmentService} from './services/appointment';
import {TeamService} from './services/teamService';
import {ServiceLevelService} from './services/service-level-service';
import {StateService} from './services/stateService';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.html',
  styleUrls: ['app.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatFormFieldModule
  ]
})
export class AppComponent {

  loaded: boolean;
  static version : string = '0.0.23';
  constructor(

    private router: Router,
    private route : ActivatedRoute,
    public authService : AuthService,
    public stateService : StateService,
    private storageService: LocalStorageService,
    private titleService : Title,
    private translate : TranslateService,

    ) {
    this.loaded = false;
    console.log('Starting version ', AppComponent.version);
    console.log(environment.appConfig);


    State.config = {
      host: environment.appConfig.externalHostAddr,
      environment: environment.appConfig.environment,
      providerId : environment.providerId,
    };



    if (environment.production) {
         // window.console.log = () => { }
    }
    let title: string = 'Huddy Scheduling App';
    if ( environment.appConfig.environment.toLowerCase().indexOf('qa') > -1) {
      title = title + '-QA';
    } else if ( environment.appConfig.environment.toLowerCase().indexOf('stg') > -1) {
      title = title + '-STG';
    } else if ( environment.appConfig.environment.toLowerCase().indexOf('prod') == -1) {
      title = title + '-DEV';
    }
    title = title + '-' + AppComponent.version;
    this.titleService.setTitle(title);

    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
          let s = this.router.url;
          console.log(s);
          if (s.startsWith('/'))
              s = s.substring(1);
          let idx = s.indexOf('/');
          if (idx > -1)
              s = s.substring(0, idx);


          console.log('Recruitment', 'updating page to ', s);


          // Send UI events to ELK
//          if (CommonService.currentUserToView){
            //Only log page visits of actual users
//            this.store.dispatch(new TrackUIEvent("Visited Page /" + s));
//          }
      }
  });

  }

  ngOnInit() {
    timer(1000).subscribe(t => this.initialize());
  }

  initialize() {
      console.log('initialize');


        let fromCookie : string | null  = this.getCookie("jwt");
        if (fromCookie) {
          console.log('got fromCookie', fromCookie);
          this.startupWithJwt('Bearer ' + fromCookie);
        } else {
          try {
          const jwt =this.storageService.get('jwt');
          if (null != jwt)
           this.startupWithJwt(jwt);
          else
           this.router.navigate(['signin']);
        } catch(err) {
          console.log( 'Recruitment',"ERROR IN APP COMPONENT STARTUP");
          console.log( 'Recruitment', 'Recruitment',err);
        }
      }

    }

    startupWithJwt(jwt : string) {
      var hasJWTToken = (jwt !== null);
      if (!hasJWTToken && State.jwt) {
        jwt = State.jwt;
        hasJWTToken = true;
      }
      console.log( 'Recruitment','App component: Has jwt token = ' + hasJWTToken);
      // document.addEventListener("backbutton", function(e) {
      //     console.log( "disable back button")
      // }, false);
      // if(hasJWTToken && !CommonService.isLoggedOut()) {
        // CommonService.setJWT(jwt);
        console.log( 'Recruitment',"attempting from app.component");
        // this.commonService.refreshCurrentUser(jwt, true);
      this.translate.setDefaultLang(State.language);
      this.translate.use(State.language);
      this.translate.addLangs(['en', 'es']);
      State.isLoaded = false;
      const browserLang = this.translate.getBrowserLang();
      this.translate.use(browserLang && browserLang.match(/en|es/) ? browserLang : 'en');
      if (hasJWTToken) {
        console.log('hasJWTToken', true)
        this.authService.getAccount(jwt).subscribe( {
          next: (t) => {
            this.loaded = true;

            if (t.login) {
              State.setJwt(jwt);
              this.authService.setUserAuth(jwt, t.login, t);
              this.stateService.loadInitialState();
              console.log('goto home');

              this.router.navigate(['home']);
            } else {
              this.storageService.remove('jwt');
              State.user = undefined;
              console.log('goto login 0');
              this.loaded = true;
              this.router.navigate(['signin']);
            }

          },
          error : (e) => {
            console.error(e);
            this.loaded = true;
            console.log('goto login 1');
            this.router.navigate(['signin']);

          }
        } )


      } else {
        console.log('goto login2');
        this.router.navigate(['signin']);
      }
    }




   getCookie(name: string) {
      let ca: Array<string> = document.cookie.split(';');
      let caLen: number = ca.length;
      let cookieName = `${name}=`;
      let c: string;

      for (let i: number = 0; i < caLen; i += 1) {
          c = ca[i].replace(/^\s+/g, '');
          if (c.indexOf(cookieName) == 0) {
              return c.substring(cookieName.length, c.length);
          }
      }
      return '';
  }

}

